import "./index.css";
import React from "react";
import { render } from "react-dom";
import { App } from "./App";

// Ensure a correct viewport meta tag — Magic Patterns' default HTML shell
// sometimes ships without one, which causes iOS Safari to render the page at
// 980px logical layout width and scale down. That breaks `useIsMobile` and
// makes the chat panel render in desktop mode on real phones.
if (typeof document !== 'undefined') {
  let meta = document.querySelector('meta[name="viewport"]') as HTMLMetaElement | null;
  if (!meta) {
    meta = document.createElement('meta');
    meta.name = 'viewport';
    document.head.appendChild(meta);
  }
  meta.content = 'width=device-width, initial-scale=1, viewport-fit=cover';
}
render(<App data-id="element-2358" />, document.getElementById("root"));